<template>
  <div class="main">
    <!-- 立即开票 -->
    <div class="header-block">
      <div class="header-banner"></div>
      <div class="header-arrow">
        <div class="header-arrow-l">
          <el-icon @click="emits('changePage', 'blueInvoice_home')"><Back /></el-icon>
          <el-breadcrumb separator-icon="arrowRight">
            <el-breadcrumb-item>蓝字发票开具</el-breadcrumb-item>
            <el-breadcrumb-item>立即开票</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <el-button type="primary" plain @click="invoiceView = !invoiceView">
          <svg data-v-602d66cb="" fill="none" viewBox="0 0 16 16" width="1em" height="1em" class="t-icon t-icon-swap" style="">
            <path
              data-v-602d66cb=""
              fill="currentColor"
              d="M1.25 6h11.76L9.16 2.25l.7-.71 4.67 4.55c.34.33.1.91-.37.91H1.25V6zM14.75 10H3.02l3.81 3.6-.69.73-4.67-4.41A.53.53 0 011.84 9h12.91v1z"
              fill-opacity="0.9"
            ></path>
          </svg>
          <span style="margin-left: 5px">切换至{{ invoiceView ? "表单" : "票样" }}视图</span>
        </el-button>
      </div>
    </div>

    <div class="operate-main">
      <!-- 票样视图 -->
      <div class="invoice-box" v-show="invoiceView">
        <div class="invoice-box-title">
          <div class="tag">
            <el-tag v-if="formData.invoiceBusiness" style="background-color: #d5dcfa; color: #3658e6; border: 1px solid #3b5ce7">
              {{ formData.invoiceBusinessName }}
            </el-tag>
          </div>

          <h6>电子发票({{ formData.categoryName }})</h6>
        </div>

        <el-form ref="formRef" :model="formData">
          <!-- 开票信息 -->
          <el-row class="box-row box-info">
            <el-col :span="12">
              <div class="box-info-t">
                <div>
                  购买方信息
                  <el-button type="primary" link @click="showMore = !showMore">
                    <el-icon><ArrowUp v-if="showMore" /><ArrowDown v-else /></el-icon>
                  </el-button>
                </div>

                <section>
                  <section>
                    <el-checkbox label="是否开票给自然人" :disabled="formData.categoryCode == 2"
                                 v-model="formData.isNaturalPerson" :true-value="1" :false-value="0" />
                  </section>

                  <el-form-item label="名称" prop="buyer.name" :rules="[{ required: true, message: '不能为空', trigger: 'change' }]">
                    <div style="width: 100%; display: flex; gap: 20px">
                      <el-input v-model.trim="formData.buyer.name" placeholder="请输入" />
                      <el-button type="primary" plain icon="tickets" @click="showBuyer = true"></el-button>
                    </div>
                  </el-form-item>
                  <el-form-item label="统一社会信用代码/纳税人识别号">
                    <el-input v-model="formData.buyer.taxRegistrationNo" placeholder="请输入" />
                  </el-form-item>

                  <template v-if="showMore">
                    <el-row :gutter="20">
                      <el-col :span="16">
                        <el-form-item label="购买方地址">
                          <el-input v-model="formData.buyer.address" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="电话">
                          <el-input v-model="formData.buyer.phone" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="20">
                      <el-col :span="15">
                        <el-form-item label="购方开户银行">
                          <el-input v-model="formData.buyer.bank" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="9">
                        <el-form-item label="银行账号">
                          <el-input v-model="formData.buyer.account" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </template>
                </section>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="box-info-t">
                <div style="border-left: 2px solid #a15f3b">
                  销售方信息
                  <el-button type="primary" link @click="showMore = !showMore">
                    <el-icon><ArrowUp v-if="showMore" /><ArrowDown v-else /></el-icon>
                  </el-button>
                </div>

                <section>
                  <section>
                    <el-tooltip effect="dark" :content="`当前可开具发票额度：${usageStatist.Number_remainAmount}`" placement="top">
                      <el-button type="primary" link>查看当前可用发票额度</el-button>
                    </el-tooltip>
                  </section>

                  <el-form-item label="名称">
                    <el-input v-model.trim="formData.seller.name" :disabled="true" placeholder="请输入" />
                  </el-form-item>
                  <el-form-item label="统一社会信用代码/纳税人识别号">
                    <el-input v-model="formData.seller.taxRegistrationNo" :disabled="true" placeholder="请输入" />
                  </el-form-item>

                  <template v-if="showMore">
                    <el-row :gutter="20">
                      <el-col :span="16">
                        <el-form-item label="销方地址">
                          <el-input v-model="formData.seller.address" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="电话">
                          <el-input v-model="formData.seller.phone" :disabled="true" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="20">
                      <el-col :span="15">
                        <el-form-item label="销方开户银行">
                          <el-input v-model="formData.seller.bank" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="9">
                        <el-form-item label="银行账号">
                          <el-input v-model="formData.seller.account" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </template>
                </section>
              </div>
            </el-col>
          </el-row>
          <!-- 项目信息 -->
          <el-row class="box-row box-invoice">
            <el-col :span="24" class="el-col-1">
              <el-space :size="10">
                <el-button type="primary" icon="plus" @click="addItems">增行</el-button>
                <el-button type="default" color="#e7e7e7" :disabled="disabled" @click="deleteItems">删除</el-button>
                <el-button type="default" color="#e7e7e7" :disabled="disabled" @click="addDisCount">添加折扣</el-button>
                <el-switch v-model="formData.addedTax" :inline-prompt="true" active-text="含税" inactive-text="不含税" />
              </el-space>
              <el-space :size="10" style="margin-inline-start: auto">
                <el-button type="default" color="#e7e7e7" @click="drawerOpen">重选发票类型</el-button>
                <el-button type="default" color="#e7e7e7" @click="clearTable">清空重填</el-button>
              </el-space>
            </el-col>

            <el-col :span="24" class="el-col-2">
              <el-table :data="formData.items" :border="true" @selection-change="selection">
                <el-table-column type="selection" width="50" />
                <el-table-column label="序号" type="index" width="60" />
                <el-table-column label="项目名称" prop="name" width="300">
                  <template #header>
                    <span><b style="color: #fb5133">*</b>项目名称</span>
                  </template>
                  <template #default="{ row }">
                    <div v-if="!row.isDiscount" style="width: 100%; display: flex; column-gap: 10px">
                      <el-input v-model.trim="row.name" />
                      <el-button type="primary" plain icon="tickets" @click="checkItems(row)"></el-button>
                    </div>
                    <div v-else style="width: 100%; height: 34px; padding-left: 10px; line-height: 34px; border: 1px solid #ddd">
                      <span style="background: #fb5133; margin-right: 3px; color: #fff">折扣</span>
                      <span style="color: #fb5133">{{ row.name }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="规格型号" prop="specification">
                  <template #default="{ row }">
                    <div>
                      <el-input v-model.trim="row.specification" :readonly="row.isDiscount" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="单位" prop="unit">
                  <template #default="{ row }">
                    <div>
                      <el-input v-model.trim="row.unit" :readonly="row.isDiscount" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="数量" prop="count">
                  <template #default="{ row }">
                    <div>
                      <el-input v-model.trim="row.count" :readonly="row.isDiscount" @blur="blur(row)" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="`单价${formData.addedTax ? '(含税)' : '(不含税)'}`" prop="price">
                  <template #default="{ row }">
                    <div>
                      <el-input v-model.trim="row.price" :readonly="row.isDiscount" @blur="blur(row)" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="金额" prop="amount">
                  <template #header>
                    <span><b style="color: #fb5133">*</b>{{ `金额${formData.addedTax ? "(含税)" : "(不含税)"}` }}</span>
                  </template>
                  <template #default="{ row }">
                    <div v-if="!row.isDiscount">
                      <el-input v-model.trim="row.amount" :readonly="row.isDiscount" @blur="blur(row)" />
                    </div>
                    <div v-else style="width: 100%; height: 34px; padding-left: 10px; line-height: 34px; border: 1px solid #ddd">
                      <span style="color: #fb5133">{{ row.amount }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="税率/征收率" prop="rate">
                  <template #header>
                    <span><b style="color: #fb5133">*</b>税率/征收率</span>
                  </template>
                  <template #default="{ row }">
                    <div :style="`--el-text-color-regular:${row.isDiscount ? '#fb5133' : ''}`">
                      <el-select v-model="row.rate" :empty-values="[null, undefined]" @change="() => selectRate(row)">
                        <el-option label="请选择税率" value="" />
                        <el-option label="0%" :value="0" />
                        <el-option label="1%" :value="0.01" />
                        <el-option label="3%" :value="0.03" />
                        <el-option label="5%" :value="0.05" />
                        <el-option label="6%" :value="0.06" />
                        <el-option label="9%" :value="0.09" />
                        <el-option label="13%" :value="0.13" />
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="税额" prop="taxAmount">
                  <template #header>
                    <span><b style="color: #fb5133">*</b>税额</span>
                  </template>
                  <template #default="{ row }">
                    <div v-if="!row.isDiscount">
                      <el-input v-model.trim="row.taxAmount" :readonly="row.isDiscount" />
                    </div>
                    <div v-else style="width: 100%; height: 34px; padding-left: 10px; line-height: 34px; border: 1px solid #ddd">
                      <span style="color: #fb5133">{{ row.taxAmount }}</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>

              <div class="box-invoice-t">
                <div style="box-sizing: border-box; width: 100%; height: 50px; padding: 0 8px; line-height: 50px; display: flex">
                  <p style="width: 7%"></p>
                  <p style="width: 19%; text-align: center; font-weight: 700; color: #a15f3b">合计</p>
                  <p style="width: 53%; text-align: end; font-weight: 700">￥{{ formData.totalAmount }}</p>
                  <p style="width: 21%; text-align: end; font-weight: 700">￥{{ formData.totalTaxAmount }}</p>
                </div>
                <div style="border-top: 2px solid #a15f3b; box-sizing: border-box; width: 100%; height: 50px; padding: 0 8px; line-height: 50px; display: flex">
                  <p style="width: 7%"></p>
                  <p style="width: 19%; text-align: center; font-weight: 700; color: #a15f3b; border-right: 2px solid #a15f3b">价税合计（大写）</p>
                  <p style="width: 53%; text-align: start; font-weight: 700; box-sizing: border-box; padding-left: 40px">
                    <span style="font-weight: normal; padding-right: 10px">⊗</span>{{ formData.payee }}
                  </p>
                  <p style="width: 21%; text-align: end; font-weight: 700; box-sizing: border-box; padding-right: 100px">
                    <span style="font-weight: 700; color: #a15f3b; padding-right: 40px">(小写)</span>{{ formData.totalAddedTaxAmount }}
                  </p>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 特定信息-建筑服务 -->
          <el-row class="box-row" v-if="formData.invoiceBusiness == 1">
            <el-col>
              <div class="line-box">
                <div class="leval_big_title">
                  <h3 class="title">特定信息-建筑服务</h3>
                </div>

                <div style="margin-top: 20px">
                  <el-form :model="formData.itemsBusinessBuilding" ref="formBusinessBuildingRef">
                    <el-row :gutter="20">
                      <el-col :span="7">
                        <el-form-item label="土地增值税项目编号" label-position="top">
                          <el-input v-model.trim="formData.itemsBusinessBuilding.no" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item label="跨地（市）标志" label-position="top" prop="tag" :rules="[{ required: true, message: '请选择跨地（市）标志', trigger: ['change'] }]">
                          <el-select v-model="formData.itemsBusinessBuilding.tag" placeholder="请选择" :empty-values="['', null, undefined]" @change="itemsBusinessBuildingTagChange">
                            <el-option label="是" value="1" />
                            <el-option label="否" value="0" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item
                          label="跨区域涉税事项报验管理编号"
                          prop="tagNo"
                          label-position="top"
                          :rules="[{ required: formData.itemsBusinessBuilding.tag == 1, message: '请输入跨区域涉税事项报验管理编号', trigger: ['change'] }]"
                        >
                          <el-input v-model.trim="formData.itemsBusinessBuilding.tagNo" placeholder="请输入" :disabled="formData.itemsBusinessBuilding.tag != 1" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="20">
                      <el-col :span="7">
                        <el-form-item label="建筑服务发生地" label-position="top" prop="location" :rules="[{ required: true, message: '请选择建筑服务发生地', trigger: ['change'] }]">
                          <areaSelect v-model="formData.itemsBusinessBuilding.location" v-model:name="formData.itemsBusinessBuilding.locationName" style="width: 100%" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item label="详细地址" label-position="top">
                          <el-input v-model.trim="formData.itemsBusinessBuilding.locationDetail" placeholder="请输入详细地址" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item label="建筑项目名称" label-position="top" prop="projectName" :rules="[{ required: true, message: '请输入建筑项目名称', trigger: ['change'] }]">
                          <el-input v-model.trim="formData.itemsBusinessBuilding.projectName" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 特定信息-货物运输服务 -->
          <el-row class="box-row" v-if="formData.invoiceBusiness == 2">
            <el-col>
              <div class="line-box">
                <div class="leval_big_title">
                  <h3 class="title">特定信息-货物运输服务</h3>
                </div>

                <div style="width: 100%; margin-top: 10px; line-height: 40px; display: flex">
                  <el-space :size="10">
                    <el-button type="primary" icon="plus" @click="addItemsBusinessShipping">增行</el-button>
                    <el-button type="default" color="#e7e7e7" :disabled="disabledBusinessShipping" @click="deleteItemsBusinessShipping">删除</el-button>
                    <el-button type="default" color="#e7e7e7" @click="warn()">批量导入</el-button>
                  </el-space>
                </div>

                <div style="margin-top: 20px">
                  <el-table :data="formData.itemsBusinessShipping" :border="true" @selection-change="selectionBusinessShipping">
                    <el-table-column type="selection" width="50" />
                    <el-table-column prop="type">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>运输工具种类</span>
                      </template>
                      <template #default="{ row }">
                        <el-select v-model="row.type" placeholder="请选择" :empty-values="['', null, undefined]" clearable>
                          <el-option v-for="(item, index) of businessShippingOptions" :key="index" :label="item.label" :value="item.value" />
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column prop="no">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>运输工具牌号</span>
                      </template>
                      <template #default="{ row }">
                        <div>
                          <el-input v-model.trim="row.no" placeholder="请输入" />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="dispatch">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>起运地</span>
                      </template>
                      <template #default="{ row }">
                        <div>
                          <areaSelect v-model="row.dispatch" v-model:name="row.dispatchName" />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="arrive">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>到达地</span>
                      </template>
                      <template #default="{ row }">
                        <div>
                          <areaSelect v-model="row.arrive" v-model:name="row.arriveName" />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>运输货物名称</span>
                      </template>
                      <template #default="{ row }">
                        <div>
                          <el-input v-model.trim="row.name" placeholder="请输入" />
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 特定信息-不动产经营租赁服务 -->
          <el-row class="box-row" v-if="formData.invoiceBusiness == 3">
            <el-col>
              <div class="line-box">
                <div class="leval_big_title">
                  <h3 class="title">特定信息-不动产经营租赁服务</h3>
                </div>

                <div style="margin-top: 20px">
                  <el-form :model="formData.itemsBusinessLeasing" ref="formBusinessLeasingRef">
                    <template v-for="(item, index) of formData.itemsBusinessLeasing" :key="item.key">
                      <h6 class="h6-leasing" v-if="formData.itemsBusinessLeasing.length > 1">
                        不动产信息<span v-if="index > 0">{{ index + 1 }}</span>
                      </h6>

                      <el-row :gutter="20">
                        <el-col :span="6">
                          <el-form-item label="不动产地址" label-position="top" :key="item.key" :prop="`${index}.area`" :rules="[{ required: true, message: '请选择不动产地址', trigger: ['change'] }]">
                            <areaSelect v-model="item.area" v-model:name="item.areaName" style="width: 100%" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="详细地址" label-position="top">
                            <el-input v-model.trim="item.areaDetail" placeholder="请输入详细地址" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="租赁期起止" label-position="top" :key="item.key" :prop="`${index}.startEndTime`" :rules="[{ required: true, message: '请选择租赁期起止', trigger: ['change'] }]">
                            <el-date-picker
                              v-model="item.startEndTime"
                              type="daterange"
                              value-format="YYYY-MM-DD"
                              unlink-panels
                              :clearable="false"
                              range-separator="-"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="跨地（市）标志" label-position="top" :key="item.key" :prop="`${index}.tag`" :rules="[{ required: true, message: '请选择跨地（市）标志', trigger: ['change'] }]">
                            <el-select v-model="item.tag" placeholder="请选择" :empty-values="['', null, undefined]">
                              <el-option label="是" value="1" />
                              <el-option label="否" value="0" />
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="6">
                          <el-form-item label="产权证书/不动产权证号" label-position="top" :key="item.key" :prop="`${index}.no`" :rules="[{ required: true, message: '请输入产权证书/不动产权证号', trigger: ['change'] }]">
                            <el-input v-model.trim="item.no" placeholder="请输入证书编号，若没有证书填写“无”" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="面积单位" label-position="top" :key="item.key" :prop="`${index}.unit`" :rules="[{ required: true, message: '请选择面积单位', trigger: ['change'] }]">
                            <el-select v-model="item.unit" placeholder="请选择" :empty-values="['', null, undefined]">
                              <el-option v-for="(item, index) of unitOptions" :key="index" :label="item.label" :value="item.value" />
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </template>
                  </el-form>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 备注信息 -->
          <el-row class="box-row">
            <el-col :span="24">
              <div class="line-box">
                <div class="leval_big_title">
                  <h3 class="title">备注信息</h3>
                  <div style="margin-inline-start: auto">
                    <el-button type="primary" link @click="showBeizhu = !showBeizhu">
                      <template v-if="showBeizhu">
                        <span>收起更多</span><el-icon style="margin-left: 10px"><ArrowUp /></el-icon>
                      </template>
                      <template v-else>
                        <span>查看更多</span><el-icon style="margin-left: 10px"><ArrowDown /></el-icon>
                      </template>
                    </el-button>
                  </div>
                </div>

                <el-form-item label="备注" prop="remark" label-position="top" style="width: 100%">
                  <el-input v-model.trim="formData.remark" type="textarea" placeholder="如开票人对备注文本长度等有特殊需求，应通过自定义附加要素录入" />
                </el-form-item>

                <template v-if="showBeizhu">
                  <el-form-item label="选择场景" label-position="top">
                    <el-input placeholder="请输入搜索" :disabled="true" style="width: 25%" />
                  </el-form-item>
                  <div style="margin: 20px 0 0 80px">
                    <el-button type="default" icon="plus" @click="warn()">添加附加内容</el-button>
                  </div>
                </template>
              </div>
            </el-col>
          </el-row>
          <!-- 经办人信息 -->
          <el-row class="box-row">
            <el-col :span="24">
              <div class="line-box">
                <div class="leval_big_title">
                  <h3 class="title">经办人信息</h3>
                  <div style="margin-inline-start: auto">
                    <el-button type="primary" link @click="showMarker = !showMarker">
                      <template v-if="showMarker">
                        <span>收起更多</span><el-icon style="margin-left: 10px"><ArrowUp /></el-icon>
                      </template>
                      <template v-else>
                        <span>查看更多</span><el-icon style="margin-left: 10px"><ArrowDown /></el-icon>
                      </template>
                    </el-button>
                  </div>
                </div>

                <template v-if="showMarker">
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <el-form-item label="姓名" prop="marker" label-position="top">
                        <el-input v-model.trim="formData.maker" placeholder="请输入" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="国籍（地区）" prop="nationality" label-position="top">
                        <el-select v-model="formData.nationality" placeholder="请选择" :empty-values="[null, undefined]">
                          <el-option label="请选择" value="" />
                          <el-option label="中华人民共和国" value="中华人民共和国" />
                          <el-option label="中国台湾" value="中国台湾" />
                          <el-option label="中国香港特别行政区" value="中国香港特别行政区" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="证件类型" prop="certifyType" label-position="top">
                        <el-select v-model="formData.certifyType" placeholder="请选择" :empty-values="[null, undefined]">
                          <el-option label="请选择" value="" />
                          <el-option label="组织机构代码证" value="组织机构代码证" />
                          <el-option label="营业执照" value="营业执照" />
                          <el-option label="税务登记证" value="税务登记证" />
                          <el-option label="其他单位证件" value="其他单位证件" />
                          <el-option label="居民身份证" value="居民身份证" />
                          <el-option label="军官证" value="军官证" />
                          <el-option label="武警警官证" value="武警警官证" />
                          <el-option label="士兵证" value="士兵证" />
                          <el-option label="军队离退休干部证" value="军队离退休干部证" />
                          <el-option label="残疾人证" value="残疾人证" />
                          <el-option label="残疾军人证(1-8级)" value="残疾军人证(1-8级)" />
                          <el-option label="外国护照" value="外国护照" />
                          <el-option label="香港永久性居民身份证" value="香港永久性居民身份证" />
                          <el-option label="台湾身份证" value="台湾身份证" />
                          <el-option label="澳门特别行政区永久性居民身份证" value="澳门特别行政区永久性居民身份证" />
                          <el-option label="中国护照" value="中国护照" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="证件号码" prop="certifyNumber" label-position="top">
                        <el-input v-model.trim="formData.certifyNumber" placeholder="请输入" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="自然人纳税人识别号" prop="nationTaxNumber" label-position="top">
                        <el-input v-model.trim="formData.nationTaxNumber" placeholder="请输入" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 表单视图 -->
      <div class="common-box" v-show="!invoiceView">
        <el-form ref="formRef" :model="formData">
          <el-row :gutter="20" class="box-row">
            <el-col :span="12">
              <div class="line-box">
                <div class="leval_big_title">
                  <h3 class="title">购买方信息</h3>
                  <el-checkbox label="是否开票给自然人" :disabled="formData.categoryCode == 2" v-model="formData.isNaturalPerson" :true-value="1" :false-value="0" style="margin-left: 20px" />
                  <div style="margin-inline-start: auto">
                    <el-button type="primary" link @click="showMore = !showMore">
                      <template v-if="showMore">
                        <span>收起更多</span><el-icon style="margin-left: 10px"><ArrowUp /></el-icon>
                      </template>
                      <template v-else>
                        <span>查看更多</span><el-icon style="margin-left: 10px"><ArrowDown /></el-icon>
                      </template>
                    </el-button>
                  </div>
                </div>
                <el-form-item label="名称" prop="buyer.name" :rules="[{ required: true, message: '不能为空', trigger: 'change' }]">
                  <div style="width: 100%; display: flex; gap: 20px">
                    <el-input v-model.trim="formData.buyer.name" placeholder="请输入" />
                    <el-button type="primary" plain icon="tickets" @click="showBuyer = true"></el-button>
                  </div>
                </el-form-item>
                <el-form-item label="统一社会信用代码/纳税人识别号">
                  <el-input v-model="formData.buyer.taxRegistrationNo" placeholder="请输入" />
                </el-form-item>
                <template v-if="showMore">
                  <el-form-item label="购买方地址">
                    <el-input v-model="formData.buyer.address" placeholder="请输入" />
                  </el-form-item>
                  <el-form-item label="电话">
                    <el-input v-model="formData.buyer.phone" placeholder="请输入" />
                  </el-form-item>
                  <el-form-item label="购方开户银行">
                    <el-input v-model="formData.buyer.bank" placeholder="请输入" />
                  </el-form-item>
                  <el-form-item label="银行账号">
                    <el-input v-model="formData.buyer.account" placeholder="请输入" />
                  </el-form-item>
                </template>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="line-box">
                <div class="leval_big_title">
                  <h3 class="title">销售方信息</h3>
                  <span style="margin-inline-start: 5px; display: flex; align-items: center">
                    <el-icon color="#409eff"><QuestionFilled /></el-icon>

                    <el-tooltip effect="dark" :content="`当前可开具发票额度：${usageStatist.Number_remainAmount}`" placement="top">
                      <el-button style="margin-left: 10px" type="primary" link>查看当前可用发票额度</el-button>
                    </el-tooltip>
                  </span>
                  <div style="margin-inline-start: auto">
                    <el-button type="primary" link @click="showMore = !showMore">
                      <template v-if="showMore">
                        <span>收起更多</span><el-icon style="margin-left: 10px"><ArrowUp /></el-icon>
                      </template>
                      <template v-else>
                        <span>查看更多</span><el-icon style="margin-left: 10px"><ArrowDown /></el-icon>
                      </template>
                    </el-button>
                  </div>
                </div>
                <el-form-item label="名称">
                  <el-input v-model.trim="formData.seller.name" :disabled="true" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="统一社会信用代码/纳税人识别号">
                  <el-input v-model="formData.seller.taxRegistrationNo" :disabled="true" placeholder="请输入" />
                </el-form-item>
                <template v-if="showMore">
                  <el-form-item label="销方地址">
                    <el-input v-model="formData.seller.address" placeholder="请输入" />
                  </el-form-item>
                  <el-form-item label="电话">
                    <el-input v-model="formData.seller.phone" :disabled="true" placeholder="请输入" />
                  </el-form-item>
                  <el-form-item label="销方开户银行">
                    <el-input v-model="formData.seller.bank" placeholder="请输入" />
                  </el-form-item>
                  <el-form-item label="银行账号">
                    <el-input v-model="formData.seller.account" placeholder="请输入" />
                  </el-form-item>
                </template>
              </div>
            </el-col>
          </el-row>

          <el-row class="box-row">
            <el-col>
              <div class="line-box">
                <div class="leval_big_title">
                  <h3 class="title">开票信息</h3>
                  <el-space style="margin-left: 20px">
                    <el-tag style="background-color: #dbf9ea; color: #18b274; border: 1px solid #18b274">电子发票</el-tag>
                    <el-tag style="background-color: #fff4eb; color: #ff9b3d; border: 1px solid #ff9b3d">
                      {{ formData.categoryName }}
                    </el-tag>
                    <el-tag v-if="formData.invoiceBusiness" style="background-color: #d5dcfa; color: #3658e6; border: 1px solid #3b5ce7">
                      {{ formData.invoiceBusinessName }}
                    </el-tag>
                  </el-space>
                </div>

                <div style="width: 100%; margin-top: 10px; line-height: 40px; display: flex">
                  <el-space :size="10">
                    <el-button type="primary" icon="plus" @click="addItems">增行</el-button>
                    <el-button type="default" color="#e7e7e7" :disabled="disabled" @click="deleteItems">删除</el-button>
                    <el-button type="default" color="#e7e7e7" :disabled="disabled" @click="addDisCount">添加折扣</el-button>
                    <el-switch v-model="formData.addedTax" :inline-prompt="true" active-text="含税" inactive-text="不含税" />
                  </el-space>
                  <el-space :size="10" style="margin-inline-start: auto">
                    <el-button type="default" color="#e7e7e7" @click="drawerOpen">重选发票类型</el-button>
                    <el-button type="default" color="#e7e7e7" @click="clearTable">清空重填</el-button>
                  </el-space>
                </div>

                <div style="margin-top: 20px">
                  <el-table :data="formData.items" :border="true" @selection-change="selection">
                    <el-table-column type="selection" width="50" />
                    <el-table-column label="序号" type="index" width="60" />
                    <el-table-column label="项目名称" prop="name" width="300">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>项目名称</span>
                      </template>
                      <template #default="{ row }">
                        <div v-if="!row.isDiscount" style="width: 100%; display: flex; column-gap: 10px">
                          <el-input v-model.trim="row.name" />
                          <el-button type="primary" plain icon="tickets" @click="checkItems(row)"></el-button>
                        </div>
                        <div v-else style="width: 100%; height: 34px; padding-left: 10px; line-height: 34px; border: 1px solid #ddd">
                          <span style="background: #fb5133; margin-right: 3px; color: #fff">折扣</span>
                          <span style="color: #fb5133">{{ row.name }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="规格型号" prop="specification">
                      <template #default="{ row }">
                        <div>
                          <el-input v-model.trim="row.specification" :readonly="row.isDiscount" />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="单位" prop="unit">
                      <template #default="{ row }">
                        <div>
                          <el-input v-model.trim="row.unit" :readonly="row.isDiscount" />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="数量" prop="count">
                      <template #default="{ row }">
                        <div>
                          <el-input v-model.trim="row.count" :readonly="row.isDiscount" @blur="blur(row)" />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column :label="`单价${formData.addedTax ? '(含税)' : '(不含税)'}`" prop="price">
                      <template #default="{ row }">
                        <div>
                          <el-input v-model.trim="row.price" :readonly="row.isDiscount" @blur="blur(row)" />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="金额" prop="amount">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>{{ `金额${formData.addedTax ? "(含税)" : "(不含税)"}` }}</span>
                      </template>
                      <template #default="{ row }">
                        <div v-if="!row.isDiscount">
                          <el-input v-model.trim="row.amount" :readonly="row.isDiscount" @blur="blur(row)" />
                        </div>
                        <div v-else style="width: 100%; height: 34px; padding-left: 10px; line-height: 34px; border: 1px solid #ddd">
                          <span style="color: #fb5133">{{ row.amount }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="税率/征收率" prop="rate">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>税率/征收率</span>
                      </template>
                      <template #default="{ row }">
                        <div :style="`--el-text-color-regular:${row.isDiscount ? '#fb5133' : ''}`">
                          <el-select v-model="row.rate" :empty-values="[null, undefined]" @change="() => selectRate(row)">
                            <el-option label="请选择税率" value="" />
                            <el-option label="0%" :value="0" />
                            <el-option label="1%" :value="0.01" />
                            <el-option label="3%" :value="0.03" />
                            <el-option label="5%" :value="0.05" />
                            <el-option label="6%" :value="0.06" />
                            <el-option label="9%" :value="0.09" />
                            <el-option label="13%" :value="0.13" />
                          </el-select>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="税额" prop="taxAmount">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>税额</span>
                      </template>
                      <template #default="{ row }">
                        <div v-if="!row.isDiscount">
                          <el-input v-model.trim="row.taxAmount" :readonly="row.isDiscount" />
                        </div>
                        <div v-else style="width: 100%; height: 34px; padding-left: 10px; line-height: 34px; border: 1px solid #ddd">
                          <span style="color: #fb5133">{{ row.taxAmount }}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <template #append>
                      <div style="box-sizing: border-box; width: 100%; height: 50px; padding: 0 8px; line-height: 50px; border-bottom: 1px solid #ddd; display: flex">
                        <p style="width: 20%">合计</p>
                        <p style="width: 60%; text-align: end">￥{{ formData.totalAmount }}</p>
                        <p style="width: 20%; text-align: end">￥{{ formData.totalTaxAmount }}</p>
                      </div>
                      <div style="box-sizing: border-box; width: 100%; height: 50px; padding: 0 8px; line-height: 50px; border-bottom: 1px solid #ddd; display: flex">
                        <p style="width: 80%; text-align: end; font-weight: 700">价税合计(大写): ⊗{{ formData.payee }}</p>
                        <p style="width: 20%; text-align: end; font-weight: 700">价税合计(小写)：{{ formData.totalAddedTaxAmount }}</p>
                      </div>
                    </template>
                  </el-table>
                </div>
              </div>
            </el-col>
          </el-row>

          <!-- 特定信息-建筑服务 -->
          <el-row class="box-row" v-if="formData.invoiceBusiness == 1">
            <el-col>
              <div class="line-box">
                <div class="leval_big_title">
                  <h3 class="title">特定信息-建筑服务</h3>
                </div>

                <div style="margin-top: 20px">
                  <el-form :model="formData.itemsBusinessBuilding" ref="formBusinessBuildingRef2">
                    <el-row :gutter="20">
                      <el-col :span="7">
                        <el-form-item label="土地增值税项目编号" label-position="top">
                          <el-input v-model.trim="formData.itemsBusinessBuilding.no" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item label="跨地（市）标志" label-position="top" prop="tag" :rules="[{ required: true, message: '请选择跨地（市）标志', trigger: ['change'] }]">
                          <el-select v-model="formData.itemsBusinessBuilding.tag" placeholder="请选择" :empty-values="['', null, undefined]" @change="itemsBusinessBuildingTagChange">
                            <el-option label="是" value="1" />
                            <el-option label="否" value="0" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item
                          label="跨区域涉税事项报验管理编号"
                          prop="tagNo"
                          label-position="top"
                          :rules="[{ required: formData.itemsBusinessBuilding.tag == 1, message: '请输入跨区域涉税事项报验管理编号', trigger: ['change'] }]"
                        >
                          <el-input v-model.trim="formData.itemsBusinessBuilding.tagNo" placeholder="请输入" :disabled="formData.itemsBusinessBuilding.tag != 1" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="20">
                      <el-col :span="7">
                        <el-form-item label="建筑服务发生地" label-position="top" prop="location" :rules="[{ required: true, message: '请选择建筑服务发生地', trigger: ['change'] }]">
                          <areaSelect v-model="formData.itemsBusinessBuilding.location" v-model:name="formData.itemsBusinessBuilding.locationName" style="width: 100%" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item label="详细地址" label-position="top">
                          <el-input v-model.trim="formData.itemsBusinessBuilding.locationDetail" placeholder="请输入详细地址" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item label="建筑项目名称" label-position="top" prop="projectName" :rules="[{ required: true, message: '请输入建筑项目名称', trigger: ['change'] }]">
                          <el-input v-model.trim="formData.itemsBusinessBuilding.projectName" placeholder="请输入" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </el-col>
          </el-row>

          <!-- 特定信息-货物运输服务 -->
          <el-row class="box-row" v-if="formData.invoiceBusiness == 2">
            <el-col>
              <div class="line-box">
                <div class="leval_big_title">
                  <h3 class="title">特定信息-货物运输服务</h3>
                </div>

                <div style="width: 100%; margin-top: 10px; line-height: 40px; display: flex">
                  <el-space :size="10">
                    <el-button type="primary" icon="plus" @click="addItemsBusinessShipping">增行</el-button>
                    <el-button type="default" color="#e7e7e7" :disabled="disabledBusinessShipping" @click="deleteItemsBusinessShipping">删除</el-button>
                    <el-button type="default" color="#e7e7e7" @click="warn()">批量导入</el-button>
                  </el-space>
                </div>

                <div style="margin-top: 20px">
                  <el-table :data="formData.itemsBusinessShipping" :border="true" @selection-change="selectionBusinessShipping">
                    <el-table-column type="selection" width="50" />
                    <el-table-column prop="type">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>运输工具种类</span>
                      </template>
                      <template #default="{ row }">
                        <el-select v-model="row.type" placeholder="请选择" :empty-values="['', null, undefined]" clearable>
                          <el-option v-for="(item, index) of businessShippingOptions" :key="index" :label="item.label" :value="item.value" />
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column prop="no">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>运输工具牌号</span>
                      </template>
                      <template #default="{ row }">
                        <div>
                          <el-input v-model.trim="row.no" placeholder="请输入" />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="dispatch">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>起运地</span>
                      </template>
                      <template #default="{ row }">
                        <div>
                          <areaSelect v-model="row.dispatch" v-model:name="row.dispatchName" />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="arrive">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>到达地</span>
                      </template>
                      <template #default="{ row }">
                        <div>
                          <areaSelect v-model="row.arrive" v-model:name="row.arriveName" />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name">
                      <template #header>
                        <span><b style="color: #fb5133">*</b>运输货物名称</span>
                      </template>
                      <template #default="{ row }">
                        <div>
                          <el-input v-model.trim="row.name" placeholder="请输入" />
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </el-col>
          </el-row>

          <!-- 特定信息-不动产经营租赁服务 -->
          <el-row class="box-row" v-if="formData.invoiceBusiness == 3">
            <el-col>
              <div class="line-box">
                <div class="leval_big_title">
                  <h3 class="title">特定信息-不动产经营租赁服务</h3>
                </div>

                <div style="margin-top: 20px">
                  <el-form :model="formData.itemsBusinessLeasing" ref="formBusinessLeasingRef2">
                    <template v-for="(item, index) of formData.itemsBusinessLeasing" :key="item.key">
                      <h6 class="h6-leasing" v-if="formData.itemsBusinessLeasing.length > 1">
                        不动产信息<span v-if="index > 0">{{ index + 1 }}</span>
                      </h6>

                      <el-row :gutter="20">
                        <el-col :span="6">
                          <el-form-item label="不动产地址" label-position="top" :key="item.key" :prop="`${index}.area`" :rules="[{ required: true, message: '请选择不动产地址', trigger: ['change'] }]">
                            <areaSelect v-model="item.area" v-model:name="item.areaName" style="width: 100%" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="详细地址" label-position="top">
                            <el-input v-model.trim="item.areaDetail" placeholder="请输入详细地址" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="租赁期起止" label-position="top" :key="item.key" :prop="`${index}.startEndTime`" :rules="[{ required: true, message: '请选择租赁期起止', trigger: ['change'] }]">
                            <el-date-picker
                              v-model="item.startEndTime"
                              type="daterange"
                              value-format="YYYY-MM-DD"
                              unlink-panels
                              :clearable="false"
                              range-separator="-"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="跨地（市）标志" label-position="top" :key="item.key" :prop="`${index}.tag`" :rules="[{ required: true, message: '请选择跨地（市）标志', trigger: ['change'] }]">
                            <el-select v-model="item.tag" placeholder="请选择" :empty-values="['', null, undefined]">
                              <el-option label="是" value="1" />
                              <el-option label="否" value="0" />
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>

                      <el-row :gutter="20">
                        <el-col :span="6">
                          <el-form-item label="产权证书/不动产权证号" label-position="top" :key="item.key" :prop="`${index}.no`" :rules="[{ required: true, message: '请输入产权证书/不动产权证号', trigger: ['change'] }]">
                            <el-input v-model.trim="item.no" placeholder="请输入证书编号，若没有证书填写“无”" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="面积单位" label-position="top" :key="item.key" :prop="`${index}.unit`" :rules="[{ required: true, message: '请选择面积单位', trigger: ['change'] }]">
                            <el-select v-model="item.unit" placeholder="请选择" :empty-values="['', null, undefined]">
                              <el-option v-for="(item, index) of unitOptions" :key="index" :label="item.label" :value="item.value" />
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </template>
                  </el-form>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row class="box-row">
            <el-col>
              <div class="line-box">
                <div class="leval_big_title">
                  <h3 class="title">备注信息</h3>
                  <div style="margin-inline-start: auto">
                    <el-button type="primary" link @click="showBeizhu = !showBeizhu">
                      <template v-if="showBeizhu">
                        <span>收起更多</span><el-icon style="margin-left: 10px"><ArrowUp /></el-icon>
                      </template>
                      <template v-else>
                        <span>查看更多</span><el-icon style="margin-left: 10px"><ArrowDown /></el-icon>
                      </template>
                    </el-button>
                  </div>
                </div>

                <el-form-item label="备注" prop="remark" label-position="top" style="width: 100%">
                  <el-input v-model.trim="formData.remark" type="textarea" placeholder="如开票人对备注文本长度等有特殊需求，应通过自定义附加要素录入" />
                </el-form-item>

                <template v-if="showBeizhu">
                  <el-form-item label="选择场景" label-position="top">
                    <el-input placeholder="请输入搜索" :disabled="true" style="width: 25%" />
                  </el-form-item>
                  <div style="margin: 20px 0 0 80px">
                    <el-button type="default" icon="plus" @click="warn()">添加附加内容</el-button>
                  </div>
                </template>
              </div>
            </el-col>
          </el-row>

          <el-row class="box-row">
            <el-col>
              <div class="line-box">
                <div class="leval_big_title">
                  <h3 class="title">经办人信息</h3>
                  <div style="margin-inline-start: auto">
                    <el-button type="primary" link @click="showMarker = !showMarker">
                      <template v-if="showMarker">
                        <span>收起更多</span><el-icon style="margin-left: 10px"><ArrowUp /></el-icon>
                      </template>
                      <template v-else>
                        <span>查看更多</span><el-icon style="margin-left: 10px"><ArrowDown /></el-icon>
                      </template>
                    </el-button>
                  </div>
                </div>

                <template v-if="showMarker">
                  <el-row :gutter="20">
                    <el-col :span="6">
                      <el-form-item label="姓名" prop="marker" label-position="top">
                        <el-input v-model.trim="formData.maker" placeholder="请输入" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="国籍（地区）" prop="nationality" label-position="top">
                        <el-select v-model="formData.nationality" placeholder="请选择" :empty-values="[null, undefined]">
                          <el-option label="请选择" value="" />
                          <el-option label="中华人民共和国" value="中华人民共和国" />
                          <el-option label="中国台湾" value="中国台湾" />
                          <el-option label="中国香港特别行政区" value="中国香港特别行政区" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="证件类型" prop="certifyType" label-position="top">
                        <el-select v-model="formData.certifyType" placeholder="请选择" :empty-values="[null, undefined]">
                          <el-option label="请选择" value="" />
                          <el-option label="组织机构代码证" value="组织机构代码证" />
                          <el-option label="营业执照" value="营业执照" />
                          <el-option label="税务登记证" value="税务登记证" />
                          <el-option label="其他单位证件" value="其他单位证件" />
                          <el-option label="居民身份证" value="居民身份证" />
                          <el-option label="军官证" value="军官证" />
                          <el-option label="武警警官证" value="武警警官证" />
                          <el-option label="士兵证" value="士兵证" />
                          <el-option label="军队离退休干部证" value="军队离退休干部证" />
                          <el-option label="残疾人证" value="残疾人证" />
                          <el-option label="残疾军人证(1-8级)" value="残疾军人证(1-8级)" />
                          <el-option label="外国护照" value="外国护照" />
                          <el-option label="香港永久性居民身份证" value="香港永久性居民身份证" />
                          <el-option label="台湾身份证" value="台湾身份证" />
                          <el-option label="澳门特别行政区永久性居民身份证" value="澳门特别行政区永久性居民身份证" />
                          <el-option label="中国护照" value="中国护照" />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="证件号码" prop="certifyNumber" label-position="top">
                        <el-input v-model.trim="formData.certifyNumber" placeholder="请输入" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="自然人纳税人识别号" prop="nationTaxNumber" label-position="top">
                        <el-input v-model.trim="formData.nationTaxNumber" placeholder="请输入" />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="footer-operate">
      <el-space :size="10">
        <el-button type="default" @click="warn()">保存草稿</el-button>
        <el-button type="default" @click="preview">预览发票</el-button>
        <el-button type="primary" @click="confirmFapiao">发票开具</el-button>
      </el-space>
    </div>

    <!-- 重新选择发票类型  -->
    <el-drawer v-model="drawer.open" title="选择开具信息" direction="ttb" class="kaipiao-drawer">
      <el-form :model="drawer.invoiceData" label-position="top" ref="formInvoiceRef">
        <el-row :gutter="20" justify="space-between">
          <el-col :span="4">
            <el-form-item label="电子发票/纸质发票">
              <el-select placeholder="电子发票" :disabled="true"> </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="选择票类" prop="invoiceType" :rules="[{ required: true, message: '请选择票类', trigger: ['blur', 'change'] }]">
              <el-select v-model="drawer.invoiceData.invoiceType" placeholder="请选择" :empty-values="['', null, undefined]" clearable @change="invoiceBusinessClear" @clear="invoiceBusinessClear">
                <el-option label="增值税专用发票" value="2" />
                <el-option label="普通发票" value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="特定业务" prop="invoiceBusiness">
              <el-select v-model="drawer.invoiceData.invoiceBusiness" placeholder="请选择（非必选项）" :disabled="drawer.invoiceData.invoiceType != 2" :empty-values="['', null, undefined]" clearable>
                <el-option label="建筑服务" value="1" />
                <el-option label="货物运输服务" value="2" />
                <el-option label="不动产经营租赁服务" value="3" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="差额征税" prop="difference">
              <el-select placeholder="请选择(非必选项)" :disabled="true"> </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="减按征税" prop="reduce">
              <el-select placeholder="请选择(非必选项)" :disabled="true"> </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div style="width: 100%; display: inline-flex; justify-content: center">
          <el-button type="default" color="#e7e7e7" @click="drawer.open = false">取消</el-button>
          <el-button type="primary" @click="confirmInvoice">确定</el-button>
        </div>
      </template>
    </el-drawer>

    <el-dialog v-model="discountInfo.open" title="添加折扣" width="500" draggable>
      <div class="dialog-body">
        <div style="box-sizing: border-box; width: 100%; padding: 10px; background-color: #f9fafe">
          <p>商品金额{{ `${formData.addedTax ? "(含税)" : "(不含税)"}` }}</p>
          <p style="line-height: 40px">
            <span style="font-size: 20px; color: #333">{{ discountInfo.totalAmount }}</span>
            <span style="font-size: 14px; color: #666">{{ `共${discountInfo.count}行` }}</span>
          </p>
        </div>
        <el-form v-model="discountInfo.formData" label-position="top">
          <el-form-item label="折扣方式">
            <el-radio-group v-model="discountInfo.formData.way">
              <el-radio label="按金额折扣" value="0" />
              <el-radio label="按比例折扣" value="1" />
            </el-radio-group>
          </el-form-item>
          <template v-if="discountInfo.count > 1">
            <el-form-item label="折扣录入方式">
              <el-radio-group v-model="discountInfo.formData.recordWay">
                <el-radio label="批量折扣录入" value="0" />
                <el-radio label="逐条折扣录入" value="1" />
              </el-radio-group>
            </el-form-item>
          </template>
          <template v-if="discountInfo.formData.recordWay == 0">
            <el-form-item :label="`${['折扣金额', '折扣比例(%)'][discountInfo.formData.way]}`" :rules="[{ required: true, message: '请输入', trigger: 'blur' }]">
              <el-input v-model.trim="discountInfo.formData.amountOrRate" />
            </el-form-item>
          </template>
          <template v-if="discountInfo.formData.recordWay == 1">
            <el-form-item :lable="`折扣金额${formData.addedTax ? '(含税)' : '(不含税)'}`">
              <el-table :data="discountInfo.formData.items" :border="true">
                <el-table-column label="项目名称" prop="name" />
                <el-table-column label="金额" prop="amount" />
                <el-table-column :label="`${['折扣金额', '折扣比例(%)'][discountInfo.formData.way]}`">
                  <template #default="{ row }">
                    <div>
                      <el-input v-model.trim="row.amountOrRate" />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <template #footer>
        <div>
          <el-button type="primary" @click="discountInfo.open = false">取消</el-button>
          <el-button type="primary" @click="confirmDisCount">确认</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 选择购买方信息 -->
    <el-drawer v-model="showBuyer"
               modal-class="digital_buyer-7139"
               :show-close="false"
               title="客户信息查询" :size="880" class="buyer-drawer">

      <template #header="{ close }">
        <div>
          <h4 style="padding-bottom: 10px;color: #333333;">客户信息查询</h4>
          <el-button @click="close">关闭</el-button>
        </div>
      </template>

      <khbm-maintence :is-selected="true" @confirm="getBuyer" />
    </el-drawer>

    <!-- 选择开票项目 -->
    <el-drawer v-model="showItems"
               modal-class="digital_buyer-7139"
               :show-close="false"
               title="项目信息查询" :size="880" class="items-drawer">
      <template #header="{ close }">
        <div>
          <h4 style="padding-bottom: 10px;color: #333333;">项目信息查询</h4>
          <el-button @click="close">关闭</el-button>
        </div>
      </template>
      <spbm-maintence :is-selected="true" @confirm="getItems" />
    </el-drawer>

    <!-- 发票预览 -->
    <invoce-dialog v-model="visible" :row="formData" />
  </div>
</template>

<script setup name="BlueInvoice/invoicing">
import { numberToChinese, generateID } from "@/utils/ruoyi";
import dayjs from "dayjs";
import { pick, cloneDeep } from "lodash";
import { ElMessageBox } from "element-plus";
import invoceDialog from "../cmp/invoceDialog.vue";
import khbmMaintence from "../cmp/khbmMaintence.vue";
import spbmMaintence from "../cmp/spbmMaintence.vue";
import areaSelect from "../cmp/areaSelect.vue";
import useInvoiceStore from "@/store/modules/invoice";
import {useAllInvoice} from "@/views/digitalInvoice/invoiceQueryStatist/allInvoiceSummary.js";

const useInvoice = useInvoiceStore();
const emits = defineEmits(["changePage"]);

const formRef = ref();
const formData = ref({
  isNaturalPerson: 0,
  addedTax: false,
  buyer: {
    id: "",
    name: "",
    taxRegistrationNo: "",
    address: "",
    phone: "",
    bank: "",
    account: "",
  },
  categoryCode: "",
  categoryName: "",
  certifyNumber: "",
  certifyType: "",
  invoiceBusiness: "", // 特定业务 1建筑服务 2货物运输服务 3 不动产经营租赁服务
  invoiceBusinessName: "", // 特定业务名称
  items: [
    {
      key: generateID(),
      sort: 1,
      id: "",
      name: "",
      specification: "",
      unit: "",
      count: "",
      price: "",
      amount: "",
      rate: "",
      taxAmount: "",
    },
  ],
  // 建筑服务
  itemsBusinessBuilding: {
    ...createBusinessBuildingData(),
  },
  // 货物运输服务数据
  itemsBusinessShipping: [createBusinessShippingData()],
  // 不动产经营租赁服务
  itemsBusinessLeasing: [createBusinessLeasingData()],
  maker: "",
  makeDate: "",
  nationTaxNumber: "",
  nationality: "",
  number: "",
  payee: "",
  remark: "",
  seller: {},
  status: "正常发票",
  totalAddedTaxAmount: "",
  totalAmount: "",
  totalTaxAmount: "",
});

const showMore = ref(true); //显示更多
const showBeizhu = ref(false); //显示更多
const showMarker = ref(false); //显示更多

//重选发票类型
const drawerOpen = () => {
  drawer.invoiceData.invoiceType = formData.value.categoryCode;
  drawer.invoiceData.invoiceBusiness = formData.value.invoiceBusiness;
  drawer.open = true;
};

const {usageStatist} = useAllInvoice()

const drawer = reactive({
  open: false,
  invoiceData: {
    invoiceType: "",
    invoiceBusiness: "",
  },
});

const invoiceBusinessClear = () => {
  drawer.invoiceData.invoiceBusiness = "";
};

const invoiceTypeOptions = ["", "普通发票", "增值税专用发票"];
const invoiceBusinessOptions = ["", "建筑服务", "货物运输服务", "不动产经营租赁服务"];

watch(
  () => [formData.value.categoryCode, formData.value.invoiceBusiness],
  ([invoiceType, invoiceBusiness]) => {
    formData.value.isNaturalPerson = formData.value.categoryCode == 2 ? 0 : 0;

    formData.value.categoryName = invoiceTypeOptions[invoiceType];
    formData.value.invoiceBusinessName = invoiceBusinessOptions[invoiceBusiness];
  }
);

onMounted(() => {
  formData.value.makeDate = dayjs().format("YYYY-MM-DD");
  formData.value.seller = Object.assign({}, useInvoice.sysSetting.seller);
  if (sessionStorage.getItem("fapiao_type")) {
    const invoiceType = sessionStorage.getItem("fapiao_type");
    const invoiceBusiness = sessionStorage.getItem("fapiao_business");
    formData.value.categoryCode = invoiceType;
    formData.value.invoiceBusiness = invoiceBusiness;
    sessionStorage.removeItem("fapiao_type");
    sessionStorage.removeItem("fapiao_business");
  }
});

//保存选择开具信息
const formInvoiceRef = ref(null);
function confirmInvoice() {
  const { invoiceType, invoiceBusiness } = drawer.invoiceData;
  formInvoiceRef.value.validate((valid) => {
    if (valid) {
      drawer.open = false;
      formData.value.categoryCode = invoiceType;

      if (formData.value.invoiceBusiness != invoiceBusiness) {
        formData.value.invoiceBusiness = invoiceBusiness;
        invoiceBusinessDataReset(invoiceBusiness);
      }

      clearTable();
    }
  });
}

// 特定业务数据操作
// 建筑服务
function createBusinessBuildingData() {
  return {
    key: generateID(),
    no: "",
    tag: "",
    tagNo: "",
    location: "",
    locationName: "",
    locationDetail: "",
    projectName: "",
  };
}

// 货物运输服务
const businessShippingOptions = [
  { label: "铁路运输", value: "1" },
  { label: "公路运输", value: "2" },
  { label: "水路运输", value: "3" },
  { label: "航空运输", value: "4" },
  { label: "管道运输", value: "5" },
  { label: "其他运输工具", value: "6" },
];
function createBusinessShippingData() {
  return {
    key: generateID(),
    type: "",
    no: "",
    dispatch: "",
    dispatchName: "",
    arrive: "",
    arriveName: "",
    name: "",
  };
}
const sectionListBusinessShipping = ref([]);
const disabledBusinessShipping = computed(() => {
  return sectionListBusinessShipping.value.length > 0 ? false : true;
});

//点击增行
function addItemsBusinessShipping() {
  formData.value.itemsBusinessShipping.push(createBusinessShippingData());
}

function selectionBusinessShipping(newSelection) {
  if (newSelection.length > 0) {
    sectionListBusinessShipping.value = newSelection.map((item) => toRaw(item));
  } else {
    sectionListBusinessShipping.value = [];
  }
}

function deleteItemsBusinessShipping() {
  ElMessageBox.confirm("是否要删除选中行", "信息", {
    showCancelButton: true,
    cancelButtonText: "取消",
    confirmButtonText: "确定",
  })
    .then(() => {
      formData.value.itemsBusinessShipping = formData.value.itemsBusinessShipping.filter((item) => !sectionListBusinessShipping.value.some((it) => it.key == item.key));
    })
    .catch(() => {});
}

// 不动产经营租赁服务
function createBusinessLeasingData() {
  return {
    key: generateID(),
    area: "",
    areaName: "",
    areaDetail: "",
    startEndTime: [],
    tag: "",
    no: "",
    unit: "",
  };
}

const unitOptions = [
  { label: "米（铁路线与管道等使用）", value: "1" },
  { label: "平方千米", value: "2" },
  { label: "平方米", value: "3" },
  { label: "公顷", value: "4" },
  { label: "亩", value: "5" },
  { label: "h㎡", value: "6" },
  { label: "k㎡", value: "7" },
  { label: "㎡", value: "8" },
];

// 清除特定业务数据
function invoiceBusinessDataReset(invoiceBusiness) {
  function clearBuilding() {
    formData.value.itemsBusinessBuilding = {
      ...createBusinessBuildingData(),
    };
  }
  function clearShipping() {
    formData.value.itemsBusinessShipping = [createBusinessShippingData()];

    sectionListBusinessShipping.value = [];
  }
  function clearLeasing() {
    formData.value.itemsBusinessLeasing = [createBusinessLeasingData()];
  }

  const clears = {
    clearBuilding,
    clearShipping,
    clearLeasing,
  };
  const clearList = ["Building", "Shipping", "Leasing"];
  const clearKey = clearList[invoiceBusiness];

  clearList.forEach((item) => {
    if (item != clearKey) {
      try {
        clears[`clear${item}`]();
      } catch (e) {
        console.log(e);
      }
    }
  });
}

//警告功能
function warn(content) {
  let msg = content ? content : "本系统为教学系统，暂不支持此功能";
  ElMessageBox.confirm(msg, "信息", {
    showCancelButton: false,
    customStyle: {
      "--el-messagebox-width": "300px",
    },
  }).catch(() => {});
}

//购买方信息
const showBuyer = ref(false);

//获取购方
function getBuyer(data) {
  let bankInfo = data.bankInfoList.find((item) => item.isDefault === 1) || {};
  Object.assign(formData.value.buyer, pick({ ...toRaw(data), ...bankInfo }, Reflect.ownKeys(formData.value.buyer)));
  showBuyer.value = false;
}

//显示开票信息行

const showItems = ref(false);
let _currentRowkey = "";
const sectionList = ref([]);
const disabled = computed(() => {
  return sectionList.value.length > 0 ? false : true;
});

const discountInfo = reactive({
  open: false,
  totalAmount: 0,
  count: 0,
  formData: {
    way: "",
    recordWay: "",
    amountOrRate: "",
    items: [],
  },
});

function checkItems(row) {
  showItems.value = true;
  _currentRowkey = row.key;
}
//获取表格
function getItems(data) {
  for (let item of formData.value.items) {
    if (item.key == _currentRowkey) {
      Object.assign(item, pick(toRaw(data), Reflect.ownKeys(item)));
      item.name = `*${data.taxCategoryName}*${data.name}`;
      /* item.count = 1;
      item.amount = Number(item.count * item.price || 0).toFixed(2);
      if (formData.value.addedTax) {
        const realAmount = item.amount / (1 + Number(item.rate));
        item.taxAmount = Number(item.amount - realAmount).toFixed(2);
      } else {
        item.taxAmount = Number(item.amount * item.rate || 0).toFixed(2);
      } */
      break;
    }
  }
  showItems.value = false;
}

//点击清空重填
function clearTable() {
  formData.value.items = [
    {
      id: "",
      key: generateID(),
      sort: 1,
      name: "",
      specification: "",
      unit: "",
      count: "",
      price: "",
      amount: "",
      rate: "",
      taxAmount: "",
    },
  ];
}

let _count = 1;
//点击增行
function addItems() {
  formData.value.items.push({
    key: generateID(),
    id: "",
    sort: ++_count,
    name: "",
    specification: "",
    unit: "",
    count: "",
    price: "",
    amount: "",
    rate: "",
    taxAmount: "",
  });

  if (formData.value.invoiceBusiness == 3) {
    // 不动产经营租赁服务
    formData.value.itemsBusinessLeasing.push(createBusinessLeasingData());
  }
}

function deleteItems() {
  ElMessageBox.confirm("是否要删除选中行", "信息", {
    showCancelButton: true,
    cancelButtonText: "取消",
    confirmButtonText: "确定",
  })
    .then(() => {
      let keys = sectionList.value.map((item) => item.key);

      if (formData.value.invoiceBusiness == 3) {
        // 不动产经营租赁服务
        const sectionListIndex = keys.map((key) => formData.value.items.findIndex((item) => item.key == key));
        formData.value.itemsBusinessLeasing = formData.value.itemsBusinessLeasing.filter((item, index) => !sectionListIndex.includes(index));
      }

      let sorts = sectionList.value.map((item) => item.sort);
      let discountList = formData.value.items.filter((item) => item.isDiscount);
      discountList.forEach((item) => {
        if (!keys.includes(item.key) && sorts.includes(item.sort)) {
          keys.push(item.key);
        }
      });
      formData.value.items = formData.value.items.filter((item) => !keys.includes(item.key));
      sectionList.value = [];
    })
    .catch(() => {});
}
//点击添加折扣
function addDisCount() {
  let discountSorts = formData.value.items.filter((item) => item.isDiscount).map((el) => el.sort);
  if (sectionList.value.some((item) => discountSorts.includes(item.sort))) {
    return warn("已有折扣行，请先删除折扣数据，再添加折扣行");
  }
  if (sectionList.value.some((item) => !item.id)) {
    return warn("发票信息填写不完整!");
  }

  let totalAmount = sectionList.value.reduce((sum, pre) => {
    return (sum += Number(pre.amount || 0));
  }, 0);
  discountInfo.count = sectionList.value.length;
  discountInfo.totalAmount = Number(totalAmount || 0).toFixed(0);
  Object.assign(discountInfo.formData, { way: "0", recordWay: "0", amountOrRate: "", items: [] });
  discountInfo.formData.items = sectionList.value.map((item) => ({
    id: item.id,
    key: generateID(),
    sort: item.sort,
    name: item.name,
    amount: item.amount,
    rate: item.rate,
    amountOrRate: undefined,
    isDiscount: true,
    taxAmount: undefined,
  }));
  discountInfo.open = true;
}

function confirmDisCount() {
  if (discountInfo.formData.recordWay == 0) {
    discountInfo.formData.items.forEach((item) => {
      if (discountInfo.formData.way == 0) {
        item.amount = -Number((item.amount / discountInfo.totalAmount) * discountInfo.formData.amountOrRate).toFixed(2);
      } else {
        item.amount = -Number((discountInfo.formData.amountOrRate / 100) * item.amount || 0).toFixed(2);
      }
      if (formData.value.addedTax) {
        const realAmount = item.amount / (1 + Number(item.rate));
        item.taxAmount = Number(item.amount - realAmount).toFixed(2);
      } else {
        item.taxAmount = Number(item.amount * item.rate || 0).toFixed(2);
      }
      delete item.amountOrRate;
      formData.value.items.push(item);
    });
  } else {
    discountInfo.formData.items.forEach((item) => {
      if (discountInfo.formData.way == 0) {
        item.amount = -Number(item.amountOrRate || 0).toFixed(2);
      } else {
        item.amount = -Number((item.amountOrRate / 100) * item.amount || 0).toFixed(2);
      }
      if (formData.value.addedTax) {
        const realAmount = item.amount / (1 + Number(item.rate));
        item.taxAmount = Number(item.amount - realAmount).toFixed(2);
      } else {
        item.taxAmount = Number(item.amount * item.rate || 0).toFixed(2);
      }
      delete item.amountOrRate;
      formData.value.items.push(item);
    });
  }
  formData.value.items.sort((a, b) => a.sort - b.sort);
  discountInfo.open = false;
}

function selection(newSelection) {
  if (newSelection.length > 0) {
    sectionList.value = newSelection.map((item) => toRaw(item));
  } else {
    sectionList.value = [];
  }
}

function blur(row) {
  row.amount = Number(row.count * row.price || 0).toFixed(2);
  if (formData.value.addedTax) {
    const realAmount = row.amount / (1 + Number(row.rate));
    row.taxAmount = Number(row.amount - realAmount).toFixed(2);
  } else {
    row.taxAmount = Number(row.amount * row.rate || 0).toFixed(2);
  }
}

function selectRate(row) {
  if (formData.value.addedTax) {
    const realAmount = row.amount / (1 + Number(row.rate));
    row.taxAmount = Number(row.amount - realAmount).toFixed(2);
  } else {
    row.taxAmount = Number(row.amount * row.rate || 0).toFixed(2);
  }
}

watch(
  () => formData.value.items,
  (list) => {
    const totalAmount = list.reduce((sum, pre) => {
      return (sum += Number(pre.amount || 0));
    }, 0);

    const totalTaxAmount = list.reduce((sum, pre) => {
      return (sum += Number(pre.taxAmount || 0));
    }, 0);
    formData.value.totalAmount = Number(totalAmount).toFixed(2);
    formData.value.totalTaxAmount = Number(totalTaxAmount).toFixed(2);
    if (formData.value.addedTax) {
      formData.value.totalAddedTaxAmount = formData.value.totalAmount;
    } else {
      formData.value.totalAddedTaxAmount = Number(totalAmount + totalTaxAmount || 0).toFixed(2);
    }
    formData.value.payee = numberToChinese(formData.value.totalAddedTaxAmount);
  },
  { deep: true }
);

watch(
  () => formData.value.addedTax,
  (val) => {
    formData.value.items.forEach((item) => {
      if (val) {
        const realAmount = item.amount / (1 + Number(item.rate));
        item.taxAmount = Number(item.amount - realAmount).toFixed(2);
      } else {
        item.taxAmount = Number(item.amount * item.rate || 0).toFixed(2);
      }
    });
  }
);

const currentQa = inject('provideCurrentQa');

//点击预览按钮
const visible = ref(false);
function preview() {
  visible.value = true;
}
const getGrandchildValue = inject("getGrandchildValue");
//开具发票
async function confirmFapiao() {
  if (!formData.value.buyer.name) {
    warn("购买方名称不能为空");
    return false;
  }
  if (formData.value.items.some(item => !item.name)) {
    warn("项目名称不能为空");
    return false;
  }
  if (formData.value.items.every((item) => !item.id) || !formData.value.buyer.id) {
    warn("你需要检查发票填开界面是否填写完整!");
    return false;
  }

  if (!businessShippingCheck() || !(await businessBuildingCheck()) || !(await businessLeasingCheck())) {
    return false;
  }

  useInvoice.addBlueInvoice(formData.value, currentQa.value.sonQueType);
  let params = useInvoice.blueInvoiceList?.at(-1);
  sessionStorage.setItem("fapiao_id", params.id);
  getGrandchildValue.value.getData = () => {
    return {
      solution: JSON.stringify(editData(params)),
    };
  };
  getGrandchildValue.value.fillFinish = () => {
    return true;
  };

  sessionStorage.setItem("fapiao_type", formData.value.categoryCode);
  sessionStorage.setItem("fapiao_business", formData.value.invoiceBusiness);
  emits("changePage", "blueInvoice_openEnd");
}

function editData(data = {}) {
  const cloneData = cloneDeep(data);
  cloneData.itemsBusinessShipping = cloneData.itemsBusinessShipping[0];
  cloneData.itemsBusinessLeasing = cloneData.itemsBusinessLeasing[0];
  /*
  if (cloneData.itemsBusinessLeasing?.startEndTime) {
    cloneData.itemsBusinessLeasing.startEndTime = cloneData.itemsBusinessLeasing.startEndTime.join("~");
  } */

  return cloneData;
}

// 货物运输服务校验
function businessShippingCheck() {
  const { invoiceBusiness, itemsBusinessShipping } = formData.value;
  if (invoiceBusiness != 2) {
    return true;
  }

  if (itemsBusinessShipping.length > 0 && !itemsBusinessShipping.some((item) => Object.values(item).some((it) => !it))) {
    return true;
  } else {
    warn("你需要检查特定信息-货物运输服务填写界面是否填写完整");
    return false;
  }
}

// 建筑服务校验
const formBusinessBuildingRef = ref();
const formBusinessBuildingRef2 = ref();
const itemsBusinessBuildingTagChange = (e) => {
  if (e == 0) {
    formData.value.itemsBusinessBuilding.tagNo = "";
  }

  nextTick(() => {
    formBusinessBuildingRef.value.validateField("tagNo");
    formBusinessBuildingRef2.value.validateField("tagNo");
  });
};
function businessBuildingCheck() {
  return new Promise((resolve, reject) => {
    const { invoiceBusiness } = formData.value;
    if (invoiceBusiness != 1) {
      resolve(true);
    }

    formBusinessBuildingRef.value.validate((valid) => {
      if (!valid) {
        warn("你需要检查特定信息-建筑服务填写界面是否填写完整");
      }

      resolve(valid);
    });
    formBusinessBuildingRef2.value.validate();
  });
}

// 不动产经营租赁服务校验
const formBusinessLeasingRef = ref();
const formBusinessLeasingRef2 = ref();
function businessLeasingCheck() {
  return new Promise((resolve, reject) => {
    const { invoiceBusiness } = formData.value;
    if (invoiceBusiness != 3) {
      resolve(true);
    }

    formBusinessLeasingRef.value.validate((valid) => {
      if (!valid) {
        warn("你需要检查特定信息-不动产经营租赁服务填写界面是否填写完整");
      }

      resolve(valid);
    });
    formBusinessLeasingRef2.value.validate()
  });
}

// 切换票样视图
// 是否票样视图
const invoiceView = ref(false);
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  background-color: #f6f7fb;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  .header-block {
    flex: none;
    width: 100%;
    .header-banner {
      width: 100%;
      height: 0.64rem;
      background: #fff url("https://static.rhkj.com/renhe_fe/other/stateTax/head_log.png") no-repeat top / 100% 100%;
    }
    .header-arrow {
      width: inherit;
      height: 0.6rem;
      padding: 0 0.2rem;
      font-size: 0.18rem;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;

      .header-arrow-l {
        display: flex;
        align-items: center;
        column-gap: 0.1rem;
      }

      :deep(.el-breadcrumb) {
        .el-breadcrumb__item {
          font-size: 0.16rem;
          .el-breadcrumb__inner {
            font-weight: 400;
            line-height: 0.6rem;
            color: #333;
          }
          &:last-child {
            .el-breadcrumb__inner {
              font-weight: 700;
            }
          }
        }
      }
    }
  }

  .operate-main {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 20px;
    margin-bottom: 80px;
    overflow-y: scroll;
    .common-box {
      box-sizing: border-box;
      width: 100%;
      padding: 20px;
      border-radius: 3px;
      background-color: #fff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.07);
      :deep(.box-row) {
        &:not(:first-child) {
          margin-top: 20px;
        }
        .el-col {
          .leval_big_title {
            position: relative;
            width: 100%;
            margin-block-end: 20px;
            line-height: 40px;
            display: flex;
            align-items: center;
          }

          .line-box {
            box-sizing: border-box;
            width: 100%;
            padding: 20px 30px 20px 20px;
            border: 1px solid #eee;
            .title {
              font-size: 20px;
              color: #333;
              font-weight: 600;
            }
          }
        }
      }
    }

    .h6-leasing {
      font-size: 16px;
      font-weight: 700;
      padding: 12px 0;
    }

    .invoice-box {
      padding: 24px;
      background-color: #ffffff;
      box-sizing: border-box;
      max-width: 1720px;
      margin: 0 auto;

      .line-box {
        box-sizing: border-box;
        width: 100%;
        padding: 20px 30px 20px 20px;
        border: 1px solid #eee;

        .leval_big_title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;

          .title {
            font-size: 14px;
            color: #a15f3b;
            font-weight: 700;
          }
        }
      }

      .invoice-box-title {
        display: flex;
        justify-content: center;
        position: relative;
        margin-bottom: 50px;

        .tag {
          position: absolute;
          left: 110px;
          bottom: 0;
        }

        > h6 {
          font-size: 36px;
          color: #a15f3b;
          text-align: center;
          font-family: PingFang SC, Microsoft YaHei, Arial Regular;
          padding-bottom: 20px;
          position: relative;

          &::before,
          &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 2px;
            background-color: #a15f3b;
            left: 0;
            bottom: 0;
          }

          &::after {
            bottom: 4px;
          }
        }
      }

      .box-row {
        border-color: #a15f3b;
        border-width: 0 2px 2px 2px;
        border-style: solid;

        &:nth-of-type(1) {
          border-width: 2px;
        }

        &.box-invoice {
          .el-col-1 {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 23px;
            border-bottom: 2px solid #a15f3b;
          }

          .el-col-2 {
            :deep(thead .cell),
            :deep(thead .cell span) {
              font-weight: 700;
              color: #a15f3b;
            }

            .box-invoice-t {
              font-size: 14px;
            }
          }
        }
      }

      .box-info {
        :deep(.el-form-item__label) {
          font-weight: 700;
          color: #a15f3b;
        }
        .box-info-t {
          display: flex;
          height: 100%;

          > div {
            width: 35px;
            height: 100%;
            flex: 0 0 auto;
            border-right: 2px solid #a15f3b;
            overflow: hidden;
            color: #a15f3b;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            padding: 8px;
            flex-direction: column;

            .el-button {
              margin-top: 3px;
              color: #a15f3b;
            }
          }

          > section {
            width: 100%;
            overflow: hidden;
            box-sizing: border-box;
            padding: 24px;
            display: flex;
            flex-wrap: wrap;
            row-gap: 16px;

            > * {
              width: 100%;
            }

            .el-form-item {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
  .footer-operate {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 9;
    width: 100%;
    height: 60px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

:deep(.kaipiao-drawer) {
  height: 300px !important;
  .el-drawer__header {
    height: 60px;
    line-height: 60px;
    padding: 0;
    padding-left: 20px;
    border-bottom: 1px solid #eee;
  }
  .el-drawer__body {
    border-bottom: 1px solid #eee;
  }
}

:deep(.buyer-drawer) {
  .el-drawer__body {
    .bm_right {
      .search-box {
        .el-form-item__content {
          > .el-input,
          .el-select {
            width: 120px;
          }
        }
      }
    }
  }
}

:deep(.items-drawer) {
  .el-drawer__body {
    .bm_right {
      .search-box {
        .el-form-item__content {
          > .el-input,
          .el-select {
            width: 120px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.digital_buyer-7139 {
  pointer-events: none;
  .el-drawer {
    pointer-events: auto;
  }
  &.el-overlay {
    background-color: transparent;
  }
}
</style>
